import browserUpdate from 'browser-update';

import './browser-update.css';

browserUpdate(
  {
    required: {
      e: 77, // ms edge
      i: false, // internet explorer
      f: 67, // firefox
      o: 58, // opera
      s: 11, // safari
      c: 72, // chrome
      samsung: 10,
    },
    insecure: true,
  },
  // `test: boolean` when set to true will always show the notification for debug purposes
  false,
);
